import { Capacitor } from '@capacitor/core';

/**
 * True only inside the Capacitor native shell (spec §6).
 *
 * Every native-only branch in the app hangs off this one call. That is what
 * makes the web build's behaviour provably unchanged — in a browser this is
 * false, and each caller falls through to exactly the path it had before —
 * and it is what lets a test flip the whole app into "native" by mocking a
 * single module.
 */
export function isNative(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    // A missing or half-initialised Capacitor global must read as "web",
    // never crash the app (spec §7).
    return false;
  }
}

/**
 * Where the app lives on the public web (spec §4.1). Inside the shell the
 * document is served from `capacitor://localhost`, which is meaningless to
 * whoever receives a shared link, so outbound challenge URLs must be built
 * against this rather than `window.location.origin`.
 *
 * Also the host the universal link claims — see `lib/deepLink.ts` and
 * `public/.well-known/apple-app-site-association`.
 */
export const PUBLIC_WEB_ORIGIN = 'https://lexicon-pnm.pages.dev';

/** Origin for links the player sends to other people. */
export function shareOrigin(): string {
  return isNative() ? PUBLIC_WEB_ORIGIN : window.location.origin;
}
